<template>
  <div class="hello">
    <Top class="top"/>
    <div class="l-container">
      <div class="inner">
        <div class="article-container">
          <div class="article-header">
            <div class="breadcrumb">
              <span>当前位置：</span>
              <a @click="jump()" class="breadcrumb-link">首页</a>
              <span class="breadcrumb-separator">></span>
              <span class="breadcrumb-current">{{title}}</span>
            </div>
            <h1 class="article-title" id="contentT"></h1>
            <div class="article-meta">
              <div class="meta-item">
                <i class="el-icon-time"></i>
                <span>发布时间：</span>
                <span id="contentTime"></span>
              </div>
            </div>
          </div>
          <div class="article-content" id="concent"></div>
        </div>
      </div>
    </div>
    <FooterHtm/>
  </div>
</template>

<script>
import $http from '../ApI/request'
import FooterHtm from './FooterHtm'
import Top from './Top'

export default {
  name: 'bidsNew',
  components: {
    Top,
    FooterHtm
  },
  data() {
    return {
      id: this.$route.query.id,
      title: this.$route.query.title,
    }
  },
  mounted() {
    // 确保进入页面时滚动功能正常
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.style.position = '';
    document.body.style.height = '';
    
    this.getcontent()
  },
  methods: {
    getcontent() {
      $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list', {
        params: {
          pageSize: 1000,
          id: this.id
        }
      }).then(res => {
        if (res.data.code === 200) {
          const record = res.data.result.records[0];
          let articleContent = record.articleConten;
          
          // 处理移动端图片大小
          if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
            const target = 'width=';
            const replacement = 'width=300 max-width=100% height=auto';
            let index = 0;
            while ((index = articleContent.indexOf(target, index)) !== -1) {
              const end = index + 10;
              articleContent = articleContent.substring(0, index) + replacement + articleContent.substring(end);
              index += replacement.length;
            }
          }
          
          // 更新页面内容
          document.getElementById('contentTime').innerHTML = record.createTime;
          document.getElementById('concent').innerHTML = articleContent;
          document.getElementById('contentT').innerText = record.articleTitle;
          document.title = record.articleTitle;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    jump() {
      this.$router.push({
        name: 'HelloWorld'
      });
    }
  }
}
</script>

<style scoped>
.hello {
  background-color: #f5f5f5;
  min-height: 250px;
  /* 确保允许滚动 */
  overflow: visible;
  position: relative;
  width: 100%;
}

.top {
  height: 28px;
  line-height: 24px;
  font-family: "Microsoft YaHei";
  color: #2C3E50;
  background-color: #f5f5f5;
}

.l-container {
  width: 100%;
  padding-top: 0px;
  background: linear-gradient(rgba(12, 77, 162, 0.02), rgba(12, 77, 162, 0.05));
  /* 修改overflow-x为overflow */
  overflow: visible;
  box-sizing: border-box;
}

.inner {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.article-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
}

.article-header {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(12, 77, 162, 0.1);
}

.breadcrumb {
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
}

.breadcrumb-link {
  color: #0c4da2;
  cursor: pointer;
  transition: color 0.3s ease;
}

.breadcrumb-link:hover {
  color: #76b6ff;
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-current {
  color: #333;
}

.article-title {
  font-size: 28px;
  color: #0c4da2;
  font-weight: bold;
  margin: 20px 0;
  line-height: 1.4;
}

.article-meta {
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
}

.meta-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.meta-item i {
  margin-right: 6px;
  font-size: 16px;
  color: #0c4da2;
}

.article-content {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  font-family: FangSong, "仿宋", FangSong_GB2312, STFangsong, "华文仿宋", serif;
}

.article-content img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin: 20px 0;
}

.article-content p {
  margin: 16px 0;
}

@media screen and (max-width: 1400px) {
  .inner {
    max-width: 95%;
  }
}

@media screen and (max-width: 750px) {
  .inner {
    width: 100%;
    padding: 15px;
  }

  .article-container {
    padding: 20px 15px;
    border-radius: 6px;
  }

  .article-title {
    font-size: 22px;
    margin: 15px 0;
  }

  .article-content {
    font-size: 15px;
  }

  .breadcrumb {
    font-size: 13px;
  }

  .meta-item {
    font-size: 13px;
  }
}

@media screen and (max-width: 576px) {
  .hello {
    width: 100%;
    /* 删除overflow-x: hidden，允许滚动 */
    /* overflow-x: hidden; */
  }
  
  .inner {
    width: 100%;
    padding: 10px;
  }
  
  .article-container {
    padding: 15px 12px;
  }
  
  .article-title {
    font-size: 20px;
  }
  
  .article-content {
    font-size: 14px;
  }
  
  .article-content img {
    max-width: 100% !important;
    height: auto !important;
  }
  
  /* 修改body样式确保可以滚动 */
  /* body, html {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/bidsNew.vue